import React, { useEffect } from 'react';
import './works.css';
import boxlogo from '../../assets/box-logo.png';
import kia from '../../assets/kia.png';
import eec from '../../assets/eec.png';
import driswarya from '../../assets/dr-iswarya2.png';
import milliard from '../../assets/milliard.png';
import growth from '../../assets/tke.jpg';
import avita from '../../assets/avita.png';
import srm from '../../assets/srm.png';
import sharjah from '../../assets/sharjah.png';
import indianNippon from '../../assets/inel.png';
import serlesbake from '../../assets/serlesbakelogo.webp';
import kalinga from '../../assets/kalinga.svg';
import ssvm from '../../assets/ssvm.gif';
import srmHospitals from '../../assets/srm_hospitals.svg';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles

const worksData = [
  {
    image: indianNippon,
    role: "Technical Lead / Project Lead",
    technology: "Next.js, Django, MySQL, AWS S3, Cloudflare",
    description: "Indian Nippon Electricals Ltd - Corporate Website Revamp (2025): Redesign and rebuild of corporate website using a performance-driven React and Django architecture. Integrated custom modules and enhanced UI for accessibility.",
    bgColorClass: "bg-white"
  },
  {
    image: kalinga,
    role: "Full Stack Developer & Project Lead",
    technology: "Next.js, Django, MySQL, AWS S3, Cloudflare",
    description: "Kalinga University - Website Revamp (2026): Led end-to-end redesign and development, database design, and SEO implementation. Achieved an 8% increase in organic traffic and increased engagement time by 1m.",
  },
  {
    image: srmHospitals,
    role: "Full Stack Developer & Project Lead",
    technology: "Next.js, Firebase, Cloudflare, Cloudflare R2",
    description: "SRM Hospitals - Development & SEO Growth (2026): Complete development of digital ecosystem, SEO, and specialty pages. Drove 140% increase in organic traffic and improved engagement time by 1m 30s.",
    bgColorClass: "bg-white"
  },
  {
    image: sharjah,
    role: "Developer",
    technology: "React.js, Node.js, Azure Functions, Cloudflare, Clarity, MongoDB",
    description: "Sharjah Ports Authority (SPA) - Security Enhancement: Configuration updates, request validation, security headers, and uptime monitoring to ensure resilience under high-traffic conditions.",
  },
  {
    image: srm,
    role: "Technical Lead / Developer",
    technology: "HTML, CSS, Bootstrap 4",
    description: "SRM Group of Institutions - High-Performance 15+ Landing Pages (2025): Developed and optimized landing pages using performance-first front-end patterns and best SEO practices.",
    bgColorClass: "bg-white"
  },
  {
    image: ssvm,
    role: "Technical Lead / Developer",
    technology: "Next.js, Zoho Forms, AWS S3, Cloudflare, Clarity",
    description: "SSVM Institutions - Educational Event Website (2025): Led full website build using component-driven approach and GSAP animations. Enhanced user engagement and design fluidity.",
  },
  {
    image: eec,
    role: "Developer - Fulltime",
    technology: "WordPress",
    description: "In this project, I led a team in the development of a WordPress website, overseeing the entire process from planning to launch. We focused on creating a user-friendly interface and ensuring optimal performance.",
  },
  {
    image: boxlogo,
    role: "Developer - Fulltime",
    technology: "Django, Python",
    description: "In this project, I developed and maintained the web application using Django, Python, and SQLite3 for the backend, while creating responsive frontend interfaces with CSS and JavaScript.",
    bgColorClass: "bg-white"
  },
  {
    image: kia,
    role: "Developer - Fulltime",
    technology: "Django, Python",
    description: "I contributed to the development and maintenance of this web application using Django and Python for the backend, with SQLite3 for data management. I also worked on the frontend, building responsive interfaces using CSS and JavaScript.",
  },
  {
    image: avita,
    role: "Developer - Fulltime",
    technology: "Webflow",
    description: "In this project, I developed additional pages and built a custom CMS system using Webflow, enabling the client to easily manage and update their content. I also ensured the website was optimized for performance.",
    bgColorClass: "bg-white"
  },
  {
    image: driswarya,
    role: "Project Manager - Freelance",
    technology: "Wordpress",
    description: "In this freelance project, I was responsible for developing pages and maintaining the site’s responsiveness, ensuring it functioned seamlessly across all devices and provided a smooth user experience.",
    bgColorClass: "bg-white"
  },
  {
    image: milliard,
    role: "Project Manager - Freelance",
    technology: "Django, Python",
    description: "In this freelance project, I developed the entire website using Django and Python, with custom styling using CSS. The main highlight of the project was completing the entire website within just two days.",
    bgColorClass: "bg-white"
  },
  {
    image: growth,
    role: "Developer and Project Manager - Freelance",
    technology: "Next.js, Bootstrap CSS",
    description: "In this freelance project, I developed a website in Next.js for a construction material supplier business, handling everything from design to development and content creation to ensure a seamless user experience.",
    bgColorClass: "bg-white"
  },
  {
    image: serlesbake,
    role: "Developer and Project Manager - Freelance",
    technology: "Next.js, Django",
    description: "In this personal brand project, I developed a web application in Next.js and Django to showcase my baking services. The site features a clean and modern design, highlighting my offerings, including custom cakes and pastries.",
    bgColorClass: "bg-white"
  }
];

const Works = () => {
  useEffect(() => {
    AOS.init(); // Initialize AOS
  }, []);

  return (
    <section id='Works'>
      <div className='container'>
        <div className='text-center mt-5 mb-4' data-aos="fade-up">
          <h1>My <span className="introText">Portfolio</span></h1>
        </div>
        <div className='row'>
          {worksData.map((work, index) => (
            <div className={`col-lg-4 col-md-6 col-12 d-flex justify-content-evenly flex-wrap gap-2 mb-4`} key={index}>
              <div className="work-bar flip-card" data-aos="fade-up">
                <div className="flip-card-inner">
                  <div className="flip-card-front text-center mb-4">
                    <img src={work.image} alt="" className={`box-logo border-2 rounded-3 ${work.bgColorClass}`}  style={{ maxHeight: '80px' }} />
                    <div className='para-text'>
                      <p>Role: {work.role}</p>
                      <p className="m-0">Technology: {work.technology}</p>
                    </div>
                  </div>
                  <div className="flip-card-back text-center">
                    <p>{work.description}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Works;
